import { lazy } from "react";
export const Async = lazy(()=>import("./RegistrationPage"))